<template>
  <Icon
    v-if="type === 'icon'"
    class="intl-currency-v2"
    :name="light ? `currency-${currency}-light` : `currency-${currency}`"
  />
  <span v-else-if="type === 'text'">
    {{ current.targetCurrency.slice(0, 2) }} {{ current.targetUnit }}
  </span>
</template>

<script setup>
import { useCurrencyStore } from '@/pinia/currency'
import { Icon } from '../Icon'

const props = defineProps({
  currency: {
    type: String,
    required: true,
    default: 'USD'
  },
  /**
   * 支持多种形式展示
   * icon - Icon 图标展示货币
   * text - 文字形式展示货币
   */
  type: {
    type: String,
    default: 'icon'
  },
  light: {
    type: Boolean,
    default: false
  }
})

const currencyStore = useCurrencyStore()

const current = computed(() => {
  if (props.currency === currencyStore.current.targetCurrency) return currencyStore.current
  return currencyStore.list.find(item => item.targetCurrency === props.currency)
})
</script>

<style lang="less">
.intl-currency-v2 {
  width: 2.2858em;
}
</style>
